import React, { useState } from 'react';

import classNames from 'classnames';

import ModalDialog from 'components/ModalDialog/ModalDialog';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar-new.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import TextField from 'clean/components/common/TextField/TextField';

import styles from './EditMultipleUserGradesModal.module.scss';
import GradeInput from '../GradeInput/GradeInput';
import AssignmentSelect from '../AssignmentSelect/AssignmentSelect';
import AttachmentElement from '../AttachmentElement/AttachmentElement';

interface Props {
  onClose: () => void;
}

const EditGradeModal: React.FC<Props> = ({ onClose }) => {
  const [value, setValue] = useState('');
  const ref = React.useRef(null);

  const users = [
    { id: 1, name: 'John Deer', grade: '+5', comment: 'This is a comment' },
    { id: 2, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 3, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 4, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 5, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 6, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 7, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 8, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 9, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 11, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 22, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 33, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 44, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 55, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 66, name: 'Sara Kingston', grade: '+2', comment: undefined },
  ];

  const handleKeyDown = event => {
    const keyMoves = {
      arrowdown: 2,
      enter: 2,
      arrowright: 1,
      escape: -1,
      arrowleft: -1,
      arrowup: -2,
    };
    const move = keyMoves[event.key.toLowerCase()];

    if (move !== undefined) {
      const inputs = [...ref.current.getElementsByTagName('input')];
      const index = inputs.indexOf(event.target);
      inputs[index + move]?.focus();
      event.preventDefault();
    }
  };

  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);

  return (
    <ModalDialog
      open={true}
      hasContentPadding={false}
      onClose={onClose}
      title={'Edit grades'}
      actionsJustifyContent="center"
      actions={[
        {
          type: 'filled',
          colour: 'primary',
          label: 'Save grades',
          handler: () => null,
          startIcon: <SaveIcon />,
        },
      ]}
    >
      <div className={styles.container} ref={ref}>
        <div className={styles.columnLayout}>
          <div className={styles.columnAssignment}>
            <div className={classNames(styles.columnTitle, 'text-label')}>Assignment</div>
            <div className={styles.columnValue}>
              <AssignmentSelect value={selectedAssignmentId} onChange={setSelectedAssignmentId} />
            </div>
          </div>
          <div>
            <div className={classNames(styles.columnTitle, 'text-label')}>Date</div>
            <div className={styles.columnValue}>
              <div className={styles.date}>
                <div>
                  <CalendarIcon />
                </div>
                <div>11.05.2022</div>
              </div>
            </div>
          </div>
          <div className={styles.columnDetails}>
            <div>
              Type: <strong>Test</strong>
            </div>
            <div>
              Teacher: <strong>Alfred Heisenberg</strong>
            </div>
            <div>
              Date added: <strong>05.05.2022</strong>
            </div>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>Student</th>
                <th>Grade</th>
                <th>Comment</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => {
                return (
                  <tr key={u.id}>
                    <td className={styles.cellName}>{u.name}</td>
                    <td className={styles.cellGrade}>
                      <GradeInput
                        currentComment="This is some mysterious comment, This is some mysterious comment,This is
                        some mysterious comment,This is some mysterious comment,This is some
                        mysterious comment,"
                        currentGrade="+4"
                        newGrade={value}
                        setNewGrade={setValue}
                        showVerticalLines={true}
                        onKeyDown={handleKeyDown}
                      />
                    </td>
                    <td className={styles.cellComment}>
                      <TextField
                        placeholder="Type comment..."
                        className={styles.gradeInput}
                        onKeyDown={handleKeyDown}
                        value={value}
                        onChange={e => {
                          setValue(e.target.value);
                        }}
                      />
                    </td>
                    <td className={styles.cellAttachment}>
                      <AttachmentElement />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </ModalDialog>
  );
};

export default EditGradeModal;
